import { writable } from "svelte/store";
export class LayerManager {
    constructor(parent, layerAndStatus) {
        this.layer = layerAndStatus;
        this.parent = parent;
        this.visible = writable(true);
    }
    getId() {
        return this.layer.layer.id;
    }
    getVisibleStore() {
        return this.visible;
    }
    getVehicle() {
        return this.layer.vehicle;
    }
    getName() {
        return this.layer.layer.name;
    }
    getProperties() {
        return this.layer.layer.properties;
    }
    getVisibleVehiclesStore() {
        return this.parent.getVisibleVehiclesStore();
    }
}
